import { useState, useEffect } from 'react';

// Standard Bootstrap 5 breakpoints
const BP = {
  sm:  576,
  md:  768,
  lg:  992,
  xl:  1200,
  xxl: 1400,
} as const;

function getWidth(): number {
  const params = new URLSearchParams(window.location.search);
  if (params.get('mobile') === 'true')  return 375;
  if (params.get('mobile') === 'false') return 1280;
  return window.innerWidth;
}

interface Breakpoints {
  isMobile: boolean;   // < md  (768) — uses Mobile routes
  isSm:     boolean;   // ≥ sm  (576)
  isMd:     boolean;   // ≥ md  (768) — tablet+
  isLg:     boolean;   // ≥ lg  (992) — laptop+
  isXl:     boolean;   // ≥ xl  (1200) — desktop+
  isXxl:    boolean;   // ≥ xxl (1400) — wide desktop
  width:    number;
}

function compute(w: number): Breakpoints {
  return {
    isMobile: w <  BP.md,
    isSm:     w >= BP.sm,
    isMd:     w >= BP.md,
    isLg:     w >= BP.lg,
    isXl:     w >= BP.xl,
    isXxl:    w >= BP.xxl,
    width:    w,
  };
}

export const useBreakpoints = (): Breakpoints => {
  const [bp, setBp] = useState<Breakpoints>(() => compute(getWidth()));

  useEffect(() => {
    const update = () => setBp(compute(getWidth()));
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('orientationchange', update, { passive: true });
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  return bp;
};

// Backwards-compatible alias — existing callers of useIsMobile() still work
export const useIsMobile = (): boolean => useBreakpoints().isMobile;
